export function findParentElement(inputElement) {
    // Starting from the input element, go up the DOM tree to find the common parent ('.row')
    let parent = inputElement;
    while (parent && !parent.classList.contains("row")) {
      parent = parent.parentNode;
    }

    // If the '.row' parent is found, find the '.col-subtotal' within it
    if (parent) {
      return parent
    } else {
      // Return null or handle the case where the '.row' parent is not found
      // console.error("parent element not found");
      return null;
    }
  }

  export function findSubtotalElement(inputElement) {
    // Starting from the input element, go up the DOM tree to find the common parent ('.row')
    let parent = inputElement;
    while (parent && !parent.classList.contains("row")) {
      parent = parent.parentNode;
    }

    // If the '.row' parent is found, find the '.col-subtotal' within it
    if (parent) {
      return parent.querySelector(".col-subtotal");
    } else {
      // Return null or handle the case where the '.row' parent is not found
      console.error("Subtotal element not found");
      return null;
    }
  }